import { Theme, css } from '@emotion/react';

// V5-specific DialogTitle styles for single-line, ellipsis, compact header
export const root = ({ spacing }: Theme) => css`
  min-height: 56px;
  display: flex;
  align-items: center;
  position: relative;
  padding: ${spacing(3)};
  padding-right: 48px;
`;

export const title = ({ typography, spacing }: Theme) => css`
  flex: 1;
  padding-right: ${spacing(2)};
  font-weight: ${typography.fontWeightBold};
  font-size: ${typography.h6.fontSize};
  line-height: ${typography.h6.lineHeight};
`;

export const actionsContainer = () => css`
  position: absolute;
  right: 16px;
  top: 50%;
  transform: translateY(-50%);
  height: 100%;
  display: flex;
  align-items: center;
`;

export const closeButton = ({ colors }: Theme) => css`
  color: ${colors.iconDark};
`;
